import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useOrg } from '../hooks/useOrg';

const SelectOrganization = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { organizations, switchOrg, switching } = useOrg();

  const handleSelect = async (orgId) => {
    await switchOrg(orgId);
    navigate('/dashboard', { replace: true });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-lg">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Select Organization</h1>
          <p className="mt-2 text-gray-600">
            Welcome, {user?.first_name}. Choose an organization to continue.
          </p>
        </div>

        <div className="space-y-3">
          {organizations.map((org) => (
            <button
              key={org.id}
              onClick={() => handleSelect(org.id)}
              disabled={switching}
              className="w-full flex items-center gap-4 p-4 bg-white rounded-xl border border-gray-200 hover:border-primary hover:shadow-md transition-all text-left disabled:opacity-50"
            >
              {org.logo_url ? (
                <img
                  src={org.logo_url}
                  alt={org.name}
                  className="w-12 h-12 shrink-0 rounded-lg object-contain bg-white border border-gray-100"
                />
              ) : (
                <div className="w-12 h-12 shrink-0 rounded-lg bg-primary/10 flex items-center justify-center text-primary font-bold text-lg">
                  {org.name.charAt(0).toUpperCase()}
                </div>
              )}
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-gray-900 truncate">{org.name}</p>
                <p className="text-sm text-gray-500 capitalize">{org.role.replace('_', ' ')}</p>
              </div>
              <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SelectOrganization;
